export const DEFAULT_EXECUTION_LIMIT = 20;

export const EXECUTION_LIMITS = {
  // v1
  premium: 100,

  // v2
  small_v2: 100,
  medium_v2: 250,
  large_v2: 500,
};

export const EXECUTION_LIMITS_BY_ACCOUNT_ID = {
  // sope dev instance
  // '20438527': 500,

  // veritassteel (chad looves)
  '13702220': 500,
};

export const GRAPHQL_VERSION_BY_ACCOUNT_ID = {
  // dev account
  // '20438527': '2025-10',

  // Ana from inspiring-developmen
  // For ana some mirror/connect board columns didn't show up in 2025-07 and below

  '8750737': '2025-10',

  // Deric Raymond from njit-marcomm
  // For Deric some mirror/connect board columns didn't show up in 2025-07 and below

  '17707766': '2025-10',
};
